import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { API_MAP } from 'app/core/helpers/api.map';
import { map } from 'rxjs';
import { EventService } from './event.service';
import { removeQueryParams } from 'app/shared/components/select/helper-functions';

export const EventResolver: ResolveFn<boolean> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(EventService)
    .get(API_MAP.event + removeQueryParams(state.url).substring(1))
    .pipe(map(() => true));
};
